import React, { useEffect, useState } from "react";
// ANT DESIGN COMPONENTS
import { Drawer } from "antd";
// REDUX
import { useDispatch, useSelector } from "react-redux";
import { updateOpenDrawerAdapter } from "../../../redux/adapters/adapterSlice";
// COMPONENTS
import DrawerAdapterInformation from "../../components/drawer/DrawerAdapterInformation";
// INTERFACES
import { AdapterInterface } from "../../../interfaces/EdgeManagement.interface";
import { RootState } from "../../../app/store";

function AdaptersDrawer() {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const dispatch = useDispatch();
	const BLANK_ADAPTER = {
		auth_type: "PASSWORD",
		dictionary: {},
		lift_type: "ELEVATOR",
		name: "",
		socket_address: "",
		type: "WEBSOCKET",
		version: "",
		auth_credentials: { username: "", password: "" },
	};

	// ************************************************ */
	// USE STATE VARIABLES **************************** */
	const [data, setData] = useState<AdapterInterface>(BLANK_ADAPTER);

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */
	// LOCAL STORAGE AND VARIABLES ******************** */
	const { adapter, openDrawerAdapter } = useSelector(
		(state: RootState) => state.adapter
	);
	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const onClickClose = () => {
		dispatch(updateOpenDrawerAdapter(false));
	};
	// ************************************************* */
	// USE EFFECT ************************************** */
	useEffect(() => {
		if (adapter) {
			setData(adapter);
		}
	}, [adapter]);
	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<Drawer
			width='35%'
			placement='right'
			onClose={onClickClose}
			closable={false}
			open={openDrawerAdapter}
		>
			{data && (
				<div>
					{/** ------------------------------------------------------------- */}
					{/** ADAPTER INFORMATION */}
					<DrawerAdapterInformation data={data} />
				</div>
			)}
		</Drawer>
	);
}

export default AdaptersDrawer;
